import { PLUMBER_STATUS_LABELS, STATUS_LABELS, plumberColorStatus } from '../../shared/lifecycle';
import type { ReferralStatus } from '../../shared/types';

const COLORS: Record<ReferralStatus, string> = {
  submitted: 'var(--azure)',
  assigned: 'var(--amber)',
  recon_attached: 'var(--violet)',
  complete: 'var(--green)',
  declined: 'var(--grey)',
};

export function StatusChip({ status, plumberView = false }: { status: ReferralStatus; plumberView?: boolean }) {
  const label = plumberView ? PLUMBER_STATUS_LABELS[status] : STATUS_LABELS[status];
  // In plumber view the colour must come from the collapsed status, not the
  // raw one, or the "In Progress" collapse in PLUMBER_STATUS_LABELS is
  // undone visually the moment a recon team is attached.
  const colorStatus = plumberView ? plumberColorStatus(status) : status;
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '0.15rem 0.6rem',
        borderRadius: 999,
        background: COLORS[colorStatus],
        color: '#fff',
        fontSize: '0.8rem',
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
